<template>
	<v-container fluid>
		<div v-if="isLoaded">
			<!-- informztion -->
			<v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`"/>
            </v-row>

			<!--table head-->
			<v-divider color="black" />
			<v-row class="subtitle-2" no-gutters>
				<v-col v-for="(item, i) in headers"
					class="text-pre-wrap"
					:class="item.style" :key="i">
					{{`${item.text}` | localize }}
				</v-col>
			</v-row>
			<v-divider color="black" />

			<!-- independent chains list -->
			<div v-if="chains?.length > 0">
				<v-expansion-panels class="mb-2" v-model="panel" focusable>
					<v-expansion-panel>
						<v-expansion-panel-header class="subtitle-2 secondary--text">
							{{'Independent retail chains' | localize }}
						</v-expansion-panel-header>
						<v-expansion-panel-content class="body-2">

							<!--Marketplaces-->
							<div v-if="marketplaces?.length">
								<div class="secondary--text my-4 text-left">
									{{'Online marketplaces' | localize }}
								</div>
								<div v-for="chan in marketplaces" :key="chan.id">
									<v-row no-gutters>
										<v-col class="text-left">{{ chan.name }}</v-col>
										<v-col class="text-center">{{ chan.stores }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage)}}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage * chan.stores) }}</v-col>
										<v-col class="text-center">{{ formatNumber(salesUnits(chan)) }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.entry_fee) }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.annual_fee) }}</v-col>
										<v-col class="text-center">{{ numberRound(chan.retail_margin) * 100 }}%</v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
									</v-row>
									<v-divider />
								</div>
							</div>

							<!--Brick&mortar multibrands chains-->
							<div v-if="bm_chains?.length">
								<div class="secondary--text my-4 text-left">
									{{'Brick & mortar multi-brand chains' | localize }}
								</div>
								<div v-for="chan in bm_chains" :key="chan.id">
									<v-row no-gutters>
										<v-col class="text-left">{{ chan.name }}</v-col>
										<v-col class="text-center">{{ chan.stores }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage)}}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage *chan.stores) }}</v-col>
										<v-col class="text-center">{{ formatNumber(salesUnits(chan)) }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.entry_fee) }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.annual_fee) }}</v-col>
										<v-col class="text-center">{{ numberRound(chan.retail_margin) * 100 }}%</v-col>
										<v-col class="text-center">{{ chan.min_price }}</v-col>
										<v-col class="text-center">{{ chan.max_price }}</v-col>
										<v-col class="text-center">{{ chan.design_main }} / {{ chan.design_second}}</v-col>
									</v-row>
									<v-divider />
								</div>
							</div>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</div>
			<!-- corporate channels list -->
			<div v-if="channels?.length > 0">
				<v-expansion-panels class="mb-2" v-model="panel2" focusable>
					<v-expansion-panel>
						<v-expansion-panel-header class="subtitle-2 secondary--text">
							{{'Corporate channels' | localize }}
						</v-expansion-panel-header>
						<v-expansion-panel-content class="body-2">

							<!--onlineStores-->
							<div v-if="onlineStores?.length">
								<div class="secondary--text my-4 text-left">
									{{'Corporate online retail' | localize }}
								</div>
								<div v-for="chan in onlineStores" :key="chan.id">
									<v-row no-gutters>
										<v-col class="text-left">{{ chan.name }}</v-col>
										<v-col class="text-center">{{ chan.stores }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage)}}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage * chan.stores) }}</v-col>
										<v-col class="text-center">{{ formatNumber(salesUnits(chan)) }}</v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
									</v-row>
									<v-divider />
								</div>
							</div>
							<!--Brick&mortar corporate channels-->
							<div v-if="outlets?.length">
								<div class="secondary--text my-4 text-left">
									{{'Corporate brick&mortar channels' | localize }}
								</div>
								<div v-for="chan in outlets" :key="chan.id">
									<v-row no-gutters>
										<v-col class="text-left">{{ chan.name }}</v-col>
										<v-col class="text-center">{{ chan.stores }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage)}}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage * chan.stores) }}</v-col>
										<v-col class="text-center">{{ formatNumber(salesUnits(chan)) }}</v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
									</v-row>
									<v-divider />
								</div>
							</div>
							<!--franchaise corporate channels-->
							<div v-if="franchises?.length">
								<div class="secondary--text my-4 text-left">
									{{'Franchise stores' | localize }}
								</div>
								<div v-for="chan in franchises" :key="chan.id">
									<v-row no-gutters>
										<v-col class="text-left">{{ chan.name }}</v-col>
										<v-col class="text-center">{{ chan.stores }}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage)}}</v-col>
										<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage * chan.stores) }}</v-col>
										<v-col class="text-center">{{ formatNumber(salesUnits(chan)) }}</v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
										<v-col class="text-center"> - </v-col>
									</v-row>
									<v-divider />
								</div>
							</div>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</div>	
		</div>
		<!-- Loader -->
		<v-row v-else justify="center" class="mt-12">
            <loader />
        </v-row>
	</v-container>
</template>
<script>
import { localeNumber, roundNumber } from '../../../functions/common';
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';
	export default {
		data (){
			return {
				headers: [
					{ text: 'Available channels (multibrand)', style: 'text-left'},
					{ text: 'Number of stores', style: 'text-center' },
					{text: 'Peak market coverage (1 store)', style: 'text-center'}, 
					{text: 'Peak market coverage (entire chain)', style: 'text-center'}, 
					{text: 'Sales last year (units)', style: 'text-center'}, 
					{text: 'Entry fee $', style: 'text-center'},
					{text: 'Annual flat fee $', style: 'text-center'}, 
					{text: 'Target retail margin', style: 'text-center'}, 
					{text: 'Min preferable price $', style: 'text-center'}, 
					{text: 'Max preferable price $', style: 'text-center'},
					{text: 'Main design second design', style: 'text-center'} 
				],
				panel: 0,
				panel2: 0,
				isLoaded: false,
				text: {
					en: 'The analysis of market conditions for each retail chain selling the products is presented in the retail report, which covers both independent stores and vendor-operated outlets.',
					ro: 'Analiza condițiilor de piață pentru fiecare lanț de magazine care comercializează produsele este prezentată în raportul privind comerțul cu amănuntul, care include atât magazinele independente, cât și punctele de vânzare gestionate de furnizori.',
					ru: 'Анализ рыночной конъюнктуры для каждой розничной сети, реализующей данную продукцию, представлен в отчете о розничной торговле, который охватывает как независимые магазины, так и торговые точки, управляемые компаниями.'
				}
			}
		},		
		computed: {
			locale() {
				return this.$store.getters.locale;
			},
			game() {
				return this.$store.getters.game;
			},
			chains () {
				return this.$store.getters.chains;
			},
			channels() {
				return this.$store.getters.channels_all;
			},
			sales () {
				return this.$store.getters.sales;
			},
			// team channels
			onlineStores() {
				let stores = []
				if (this.channels.length > 0) {
					stores = this.channels.filter(channel => channel.type == 1)
				}
				return stores
			},
			outlets() {
				let stores = []
				if (this.channels.length > 0) {
					stores = this.channels.filter(channel => (channel.type == 2 || channel.type == 3))
				}
				return stores
			},
			franchises() {
				let stores = []
				if (this.channels.length > 0) {
					stores = this.channels.filter(channel => channel.type == 4)
				}
				return stores
			},
			marketplaces() {
				let stores = []
				if (this.chains.length > 0) {
					stores = this.chains.filter(channel => channel.type == 'online')
				}
				return stores
			},
			bm_chains() {
				let stores = []
				if (this.chains.length > 0) {
					stores = this.chains.filter(channel => channel.type == 'brick&mortar')
				}
				return stores
			},
			
		},
		methods: {
			//format in numeral
			formatNumber(number) {
				if (number) {
					return localeNumber(number, this.locale);
				}
				return 0
			},
			numberRound(number, dec=2) {
				return roundNumber(number, dec);
			},
			salesUnits(channel) {
				let sales = 0;
				this.sales.forEach((item) => {
					for (let i = 0; i< item.channels.length; i++) {
						if (item.channels[i] == channel.name) {
							sales+= item.channels_sales[i];
						}
					}
				});
				return sales;
			},
			lastSales(chan) {
				const inChain = this.channels?.filter(ch => ch.name == chan.name);
				if (inChain) {
					return inChain.reduce((sum, item) => {
						return sum += item.sales_last
					}, 0) ;
				}
				return 0;
			}
		},
		components: { Information, Loader },
		async created() {
			if (this.game) {

				const obj = { 
					gameId: this.game.id, 
					round: this.game.round > 0 ? this.game.round - 1 : 0
				}
				
				if (this.chains == null) {
					try {
						//get all IndependentChains
						await this.$store.dispatch('fetchChains', this.game.id);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}

				if (this.channels == null) {
					try {
						//get allChannels last year
						await this.$store.dispatch('fetchChannels', obj);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}

				if (this.sales?.length < 1) {
					try {
						//get allSales last year
						await this.$store.dispatch('fetchSales', obj);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}
			}

			this.isLoaded = true;
		}, 
	}	
</script>